<template>
  <bottom-bar-layout class="million-read-experience-vip-detail"
                     show-bar
                     :bar-height="120"
  >
    <div v-if="!inAppWebView"
         class="million-read-experience-vip-detail-header"
    >
      <div class="icon-block"
           @click="handleToHome"
      >
        <ym-icon class="icon"
                 name="back"
        />
        <span>首页</span>
      </div>
    </div>
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/01.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/02.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/03.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/04.gif')"
    />
    <router-link :to="{ name: 'MillionReadUserGuide' }">
      <img class="img"
           :src="require('@/assets/img/million_read/experience_vip/05.png')"
      />
    </router-link>
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/06.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/07.png')"
    />
    <router-link :to="{ name: 'MillionReadBookList' }">
      <img class="img"
           :src="require('@/assets/img/million_read/experience_vip/08.png')"
      />
    </router-link>
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/09.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/10.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/11.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/12.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/13.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/14.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/15.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/16.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/17.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/18.png')"
    />
    <img class="img"
         :src="require('@/assets/img/million_read/experience_vip/19.png')"
    />
    <template #tabbar>
      <div class="million-read-experience-vip-detail-bottom-bar">
        <div class="million-read-experience-vip-detail-bottom-bar-info">
          <div class="million-read-experience-vip-detail-bottom-bar-price">
            <div class="million-read-experience-vip-detail-bottom-bar-benefit-price">
              7天会员
            </div>
            <div class="million-read-experience-vip-detail-bottom-bar-gift-tag">限时领</div>
          </div>
          <div class="million-read-experience-vip-detail-bottom-bar-gift">
            <div class="million-read-experience-vip-detail-bottom-bar-gift-title">
              解读经典名著，让孩子轻松爱上阅读
            </div>
          </div>
        </div>
        <div class="million-read-experience-vip-detail-bottom-bar-action"
             v-ym-report:COIN_INVITE_POSTER_RECEIVE_CLICK="{ query }"
             @click="handleJoinExperienceVip"
        >
          免费领取
        </div>
      </div>
    </template>
    <receive-popup :show.sync="showReceivePopup"
                   :need-mobile="render.needMobile"
                   title="7天免费体验"
                   @submit-action="handleReceivePopupClose"
    />
    <result-popup :show.sync="showResultPopup"
                  :status="result.status"
                  :is-received="result.isReceived"
                  :is-new-member="isNewMember"
                  @start-learn="handleRedirectRequiredInfoPage"
                  @back-app="handleBackToApp"
    />
  </bottom-bar-layout>
</template>

<script>
  import { decorator, before } from 'ym-reporter-vue';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import ReceivePopup from '@/pages/MillionRead/components/ExperienceVipReceivePopup';
  import ResultPopup from '@/pages/MillionRead/components/ExperienceVipReceiveResultPopup';
  import {
    getExperienceVipDetail,
    receiveExperienceVip,
  } from '@/services/million-read';
  import { loginRegisterWithMobile } from '@/services/app';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'MillionReadExperienceVip',
    metaInfo: {},
    components: {
      BottomBarLayout,
      ReceivePopup,
      ResultPopup,
    },
    data() {
      return {
        render: {
          needMobile: true,
        },

        mobile: '',
        smsCode: '',
        isNewMember: false,

        showReceivePopup: false,
        showResultPopup: false,

        showWelfarePopup: false,
        result: {
          status: '',
          isReceived: false,
          needReport: false,
        },

        showExperiencePopup: false,
      };
    },
    computed: {
      query() {
        return this.$route.query ? this.$route.query : {};
      },
      inAppWebView() {
        return isAppWebView();
      },
    },
    methods: {
      async fetchData() {
        const data = await getExperienceVipDetail(this.query);
        this.render = Object.assign(this.render, data.render);
      },
      handleRedirectRequiredInfoPage() {
        this.$router.push({
          name: 'MillionReadRequiredInfo',
        });
      },
      handleBackToApp() {
        if (!this.inAppWebView) {
          this.$router.push({
            name: 'MillionReadSelect',
          });
          return;
        }
        this.handleDismissWebview();
      },
      @decorator(before(function () {
        this.$reporter.report('MILLION_EXVIP_GET_CLICK', {
          isNewMember: this.isNewMember,
        });
      }))
      async handleReceiveExperienceVip() {
        try {
          const data = await receiveExperienceVip();
          this.result = Object.assign(this.result, data);
          this.showResultPopup = true;
        } catch (e) {
          window.location.reload();
        }
      },
      async handleLogin() {
        const data = await loginRegisterWithMobile({
          type: this.activityType,
          sms_type: 'verify',
          mobile: this.mobile,
          sms_code: this.smsCode,
        });
        this.handleLoginSuccess(data.token);
        this.isNewMember = data.isNewMember;
        this.showReceivePopup = false;
        this.handleReceiveExperienceVip();
      },
      handleResetUserInfo(params) {
        this.mobile = params.mobile;
        this.smsCode = params.smsCode;
      },
      async handleReceivePopupClose(params) {
        await this.handleResetUserInfo(params);
        this.handleLogin();
      },
      async handleJoinExperienceVip() {
        if (this.render.needMobile) {
          this.showReceivePopup = true;
          return;
        }
        this.handleReceiveExperienceVip();
      },
      handleToHome() {
        this.$router.push({
          name: 'MillionReadSelect',
        });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-experience-vip-detail {
    min-height: 100%;
    background: @color-white;
    &-header {
      box-sizing: border-box;
      width: 750px;
      height: 88px;
      display: flex;
      align-items: center;
      border-bottom: @border-base;
      background: @color-white;
      .icon-block {
        box-sizing: border-box;
        height: 88px;
        padding-left: @size-base;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon {
        margin-right: 5px;
        color: #222;
        font-size: 30px;
      }
    }
    .img {
      width: 100%;
      display: block;
    }
    &-bottom-bar {
      box-sizing: border-box;
      width: 750px;
      height: 120px;
      padding: 0 @size-base;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(0deg, #f53e2e, #ff764b);
      &-price {
        display: flex;
        align-items: flex-end;
      }
      &-benefit-price {
        color: @color-white;
        font-size: 42px;
        font-weight: @font-weight-strong;
        line-height: 1;
      }
      &-origin-price {
        margin-bottom: 4px;
        color: @color-text-lighter;
        font-size: @font-size-extra-small;
        line-height: 1;
      }
      &-gift {
        margin-top: @size-extra-small;
        display: flex;
        align-items: center;
        &-tag {
          box-sizing: border-box;
          height: 36px;
          display: flex;
          align-items: center;
          margin-left: 15px;
          padding: 0 10px;
          color: #f64331;
          font-size: 24px;
          line-height: 1.1;
          background: linear-gradient(180deg, #ffffff, #ffdad7);
          box-shadow: 0 2px 2px 0 rgba(234, 58, 40, 0.55);
          border-radius: 5px;
        }
        &-title {
          color: @color-white;
          font-size: @font-size-small;
          line-height: 1;
        }
      }
      &-action {
        box-sizing: border-box;
        width: 242px;
        height: 80px;
        padding-top: @size-small;
        display: flex;
        justify-content: center;
        color: #b32b01;
        font-size: @font-size-large;
        line-height: 1;
        font-weight: @font-weight-strong;
        background: url('~@/assets/img/million_read/experience_vip/join_btn.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
</style>
